(function () {
  var html = document.documentElement;
  var KEY = 'cgxNav';
  var timer;

  function start() {
    html.classList.remove('cgx-arrive');
    void html.offsetWidth;
    html.classList.add('cgx-loading');
    try { sessionStorage.setItem(KEY, '1'); } catch (e) {}
    clearTimeout(timer);
    timer = setTimeout(stop, 12000);
  }

  function stop() {
    html.classList.remove('cgx-loading');
    try { sessionStorage.removeItem(KEY); } catch (e) {}
  }

  function sameOrigin(url) {
    try { return new URL(url, location.href).origin === location.origin; } catch (e) { return false; }
  }

  document.addEventListener('click', function (e) {
    if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest && e.target.closest('a[href]');
    if (!a || a.hasAttribute('download')) return;
    if (a.target && a.target !== '_self') return;
    var raw = a.getAttribute('href');
    if (!raw || raw.charAt(0) === '#' || /^(mailto|tel|javascript):/i.test(raw)) return;
    if (!sameOrigin(a.href)) return;
    var u = new URL(a.href, location.href);
    if (u.pathname === location.pathname && u.search === location.search) return;
    if (!e.defaultPrevented) start();
  });

  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || (f.target && f.target !== '_self')) return;
    if (!sameOrigin(f.getAttribute('action') || location.href)) return;
    if (!e.defaultPrevented) start();
  });

  window.addEventListener('pageshow', function (e) {
    if (e.persisted) stop();
  });

  try {
    if (sessionStorage.getItem(KEY)) {
      sessionStorage.removeItem(KEY);
      html.classList.add('cgx-arrive');
      setTimeout(function () { html.classList.remove('cgx-arrive'); }, 900);
    }
  } catch (e) {}
})();
